import {
    LOGIN_REQUEST,
    LOGIN_SUCCESS,
    LOGIN_FAIL,
    LOGOUT_REQUEST,
    LOGOUT_SUCCESS,
    GET_USER_REQUEST,
    GET_USER_SUCCESS,
    GET_USER_FAIL,
    PASSWORD_RESET_REQUEST,
    PASSWORD_RESET_SUCCESS,
    PASSWORD_RESET_FAIL,
    PASSWORD_CHANGE_REQUEST,
    PASSWORD_CHANGE_SUCCESS,
    PASSWORD_CHANGE_FAIL
} from '../constants/Users';
//import serverConfig from '../../server_config.json';
import {push} from 'react-router-redux';
import {sessionService} from 'redux-react-session';
import {setActiveLanguage} from 'react-localize-redux';

//const BASE_URL = serverConfig.url;
/*
if (serverConfig.host === 'localhost') {
  const BASE_URL = serverConfig.path;
} else {
  const PROTOCOL = serverConfig.protocol;
  const BASE_URL = PROTOCOL + '://' + serverConfig.host + serverConfig.path;
}
*/

export function navigateToLogin() {
    return (dispatch) => {
        dispatch(push('/login'));
    }
}

export function navigateToPasswordResetPage() {
    return (dispatch) => {
        dispatch(push('/reset-password'));
    }
}

export function navigateToPasswordChangePage() {
    return (dispatch) => {
        dispatch(push('/change-password'));
    }
}

export function navigateToCardsPage() {
    return (dispatch) => {
        dispatch(push('/'));
    }
}

export function login(e) {
    return (dispatch) => {

        // return new Promise(res => {
        //     dispatch({ type: LOGIN_REQUEST });
    
        //     const user = { sessionId: '123412', isAdmin: true };
    
        //     dispatch({ type: LOGIN_SUCCESS, payload: user });
    
        //     sessionService.saveSession({sessionId: user.sessionId});
        //     dispatch(push('/'));
    
        //     return res();
        // })

        dispatch({ type: LOGIN_REQUEST });

        return fetch(BASE_URL + 'login', {
            method: 'POST',
            body: JSON.stringify(e),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })
            .then(response => {
              console.log(response);
              if (response.ok) {
                return Promise.resolve(response);
              } else {
                return Promise.reject(response.status);
              }
            })
            .then(response => response.json())
            .then(json => {
              const user = json.user;
              dispatch({ type: LOGIN_SUCCESS, payload: user });
              return user;
            })
            .then(user => {
                if (user) {
                    sessionService.saveSession({sessionId: user.sessionId});
                    dispatch(push('/'));
                }
            })
            .catch((error) => {
              console.error('Kirjautuminen epäonnistui ' + error + '.');
              dispatch({ type: LOGIN_FAIL, payload: error });
              throw '';
            });
    }
}

export function logout() {
    return (dispatch) => {
        dispatch({
            type: LOGOUT_REQUEST
        });

        return sessionService.saveSession({sessionId: undefined})
            .then(() => {
                dispatch({
                    type: LOGOUT_SUCCESS
                });
                dispatch(navigateToLogin());
            });
    }
}

export function getUserBySessionId(sessionId) {
    return (dispatch) => {
        dispatch({
            type: GET_USER_REQUEST
        });

        // return new Promise(res => {
        //     dispatch({
        //         type: GET_USER_SUCCESS,
        //         payload: { sessionId, isAdmin: true }
        //     });
        //     res();
        // })

        return fetch(BASE_URL + 'users/' + sessionId)
            .then(
              response => {
                if (response.ok) {
                  return response.json();
                } else {
                  throw 'No such session id';
                }
                //console.log(response);
              }
            )
            .then(json => {
                if (json.error) {
                    dispatch({
                        type: GET_USER_FAIL,
                        payload: json.error
                    });
                    throw json.error;
                } else {
                    const user = json.user;
                    dispatch({
                        type: GET_USER_SUCCESS,
                        payload: user
                    });
                    return user;
                }
            });
            //.catch(e => {
            //    console.log(e);
            //    dispatch(push('/login'))
            //});
    }
}

export function resetPassword(login) {
    return (dispatch) => {
        dispatch({
            type: PASSWORD_RESET_REQUEST
        });

        return fetch(BASE_URL + 'resetPassword/', {
            method: 'POST',
            body: JSON.stringify(login),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })
            .then(response => {
                if (response.ok) {
                    dispatch({type: PASSWORD_RESET_SUCCESS});
                    setTimeout(() => {
                        dispatch(navigateToLogin());
                    }, 2000);
                } else {
                    throw 'Salasanaa ei pystytty uudelleenasettamaan.';
                }
            })
            .catch(err => dispatch({type: PASSWORD_RESET_FAIL, payload: err}));
    }
}

export function changePassword(formValues) {
    return (dispatch, getState) => {
        dispatch({type: PASSWORD_CHANGE_REQUEST});

        sessionService.loadSession()
            .then(currentSession => {
                const content = {
                    login: getState().user.login,
                    password: formValues.newPassword,
                    oldpassword: formValues.oldPassword
                }

                return fetch(BASE_URL + 'changePassword/', {
                    method: 'POST',
                    body: JSON.stringify(content),
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'X-session-Id': currentSession.sessionId
                    }
                })
                    .then(response => {
                        if (response.ok) {
                            dispatch({type: PASSWORD_CHANGE_SUCCESS});
                            setTimeout(() => {
                                dispatch(navigateToCardsPage());
                            }, 2000);
                        } else {
                            throw `Salasanaa ei onnistuttu vaihtamaan. (${response.status})`;
                        }
                    })
                    .catch(err => {
                        dispatch({type: PASSWORD_CHANGE_FAIL, payload: err})
                    });
        });
    }
}

export function changeLanguage(e) {
    return (dispatch) => dispatch(setActiveLanguage(e.target.value));
}



// WEBPACK FOOTER //
// ./src/actions/UserActions.js